// import vuetify from './plugins/vuetify';
import Vue from 'vue';
import VueRouter from 'vue-router';

import App from './App';
import { routes } from './routes';
import { store} from './store/store'

import { i18n } from "./translations/i18n";

import {
	getLocationDataArray,
	getContentObjects,
	createUrlString,
	getIdFromItemName,
	getURLFromItemName
} from "./store/helpers";
import axios from "axios";
import VueAccessibleModal from 'vue-accessible-modal'

const options = {
	transition: 'fade',
}

Vue.use(VueAccessibleModal, options)


AUI().use('liferay-portlet-url')

Vue.use(VueRouter);

const router = new VueRouter({
	// mode: 'history',
	routes
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {

	// Start with setting tukaReady info to state
	store.dispatch('tukaReady', false);

	if (from.name) { // in-application route change
		store.dispatch('initialLoad', false)

		setNavigationInformation(to, from);
	} else { // initial route change (first load)
		initializePortlet(to, from)
	}

	// TODO: add locale handling
	if (i18n.locale !== 'fi') {
		if (!to.query.hasOwnProperty('lang') && (from.query.hasOwnProperty('lang'))) {
			return next({name: to.name, query: from.query})
		} else {
			return next()
		}
	} else {
		next()
	}
})

new Vue({
	i18n,
	router,
	store,
	el: '#_fi_yja_tuka_portlet_TukaWebPortlet_app',
	render: h => h(App),
	data() {
		return {
			portletId: 'fi_yja_tuka_portlet_TukaWebPortlet',
			containerId: '_fi_yja_tuka_portlet_TukaWebPortlet_container'
		}
	}
});

function initializePortlet(to, from) {
	
	/* Settings initialization */
	let sidebarAccordionLevel = "";
	sidebarAccordionLevel = document.getElementById("_fi_yja_tuka_portlet_TukaWebPortlet_container").getAttribute('setting-sidebaraccordionlevel');
	
	let tempSettings = store.getters['getSettings'];
	if (sidebarAccordionLevel !== "") {
		tempSettings.accordionActivationLevel = sidebarAccordionLevel
	}
	store.dispatch('setSettings', tempSettings);

	/* Content initialization */
	const groupId = themeDisplay.getScopeGroupId();
	const sidebarWebContentId = document.getElementById("_fi_yja_tuka_portlet_TukaWebPortlet_container").getAttribute('setting-sidebarwebcontentid');
	axios.get('/o/indesign-rest/indesign/get-navigation/' + "groupId/" + groupId + "/articleId/" + sidebarWebContentId,
			{
					headers: {
							'Content-Type': 'application/json',
							'Accept': 'application/json'
					},
					timeout: 30000
			}
	).then(response => {

			// REROUTE CHECK
			// If page is hardloaded without target (e.g. .../tv#/) reroute into default view of first
			// available sidebar item (e.g. .../tv#/xml-testijulkaisu-3132022)
			if (!to.name) {
				router.push({
					name: 'componentpage', 
					params: { 
						componentPage: createUrlString(response.data.sidebar[0].name)
					} 
				}).catch(err => { console.log("Rerouted to same location")})

				return; // Prevent further code execution after rerouting
			}

			// Initialize themeWords-filters
			if (response.data.sidebar[0].themeWords) {
				store.dispatch('initThemeWords', response.data.sidebar[0].themeWords);
			}


			/**
			 * Transform navigationIndex into array and insert it into item, used for url navigation
			 * e.g. header with navigationIndex="1.3" means url of ...#/1/3
			 * @param {Object} item 
			 */
			function setLocationDataRecursively(item) {
				let navigationArray = [];
				if (item.navigationIndex) {
					if (item.navigationIndex.match(/[a-z]/i)) {
						// remove html tags from name string
						let regex = /(<([^>]+)>)/ig;
						let urlName = item.name.replace(regex,"")

						navigationArray.push(getURLFromItemName(urlName));
						store.dispatch('setHeadersWithoutNumber', getURLFromItemName(item.name));
					} else {
						navigationArray = item.navigationIndex.split("."); // "1.2.1" --> ["1","2","1"]
					}
				}
				navigationArray.unshift("0"); // ["1","2","1"] --> ["0","1","2","1"]

				item.locationData = navigationArray; // Insert into item to be used later for navigation
				// If item has child items, loop through them
				if (item.items) {
					item.items.forEach((singleItem, index) => {
						setLocationDataRecursively(singleItem)
					});
				}
			}
			
			/*
			function setLocationDataRecursively(item, locationData, itemIndex) {
				
				// 1. Deconstruct parentItems into new array (new array, not a reference to existing one)
				let locationDataArray = [...locationData];				
				
				// 2. Set item.locationData as given array (e.g. [0, 1])
				item.locationData = locationDataArray;
				
				// 3. Push given itemIndex into array, e.g. [0, 1] --> [0, 1, 2]
				locationDataArray.push(itemIndex);
				
				// 4. If item has child items, loop through them and repeat steps 1-4
				if (item.items) {
					item.items.forEach((singleItem, index) => {
						setLocationDataRecursively(singleItem, locationDataArray, index)
					});
				}
			}
			*/

			// Set locationData arrays into every sidebar item, used for URL creation/navigation
			setLocationDataRecursively(response.data.sidebar[0]);

			// Initialize sidebar content
			store.dispatch('setSidebarContent', response.data).then(() => {
				
				// Set root element (including attachments info) to state during initialization
				const rootItemContentId = store.getters['sidebarContent'][0].contentId;
				const groupId = themeDisplay.getScopeGroupId();
				let targetUrl = '/o/indesign-rest/indesign/get-articles/' + "groupId/" + groupId + "/articleIds/" + rootItemContentId
				axios.get(targetUrl, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json'}, timeout: 30000 }).then(response => {
					if (response.data.articles.length) {
						store.dispatch('initRootItem', response.data.articles[0]);
					}
				}).catch(error => { console.log("Error in sidebar content generation") })

				Vue.nextTick(function() {
					
					// If menu toggle is visible (mobile mode) close the menu
					if (jQuery('.settings-box.visual-settings:visible').length) {

						// Add information about mobile mode to main element
						jQuery('#tuka').addClass("mobile-mode");

						let tempSettings = {...store.getters['getSettings']};
						tempSettings.showContentWindowInFullWidth = true; // closes mobile menu 
						store.dispatch('setSettings', tempSettings);
					}
				});

				setNavigationInformation(to, from);
			});
		})
		.catch(error => {
			console.log("Error in sidebar content initialization");
		})
}

function setNavigationInformation(to, from) {
	// REROUTE CHECK
	// If page is changed into root (e.g. .../tv#/xml-testijulkaisu-3132022 --> .../tv#/) 
	// reroute into default view of first available sidebar item (e.g. .../tv#/xml-testijulkaisu-3132022)
	if (!to.name) {
		router.push({
			name: 'componentpage', 
			params: { 
				componentPage: createUrlString(store.getters['sidebarContent'][0].name)
			} 
		}).catch(err => { console.log("Rerouted to same location")})

		return; // Prevent further code execution after rerouting
	}

	/* 1. Set hash from URL to state*/

	if (to.hash) {
		store.dispatch('setHash', to.hash);

		// If hash is present, allow page to scroll to hash target without interference
		Vue.nextTick(function() {
			store.dispatch('setScrollingReserved', true);
		})

	} else {
		// Reset possibly active visibleContentId value during route change
		store.dispatch('setVisibleContentId', 0);
	}

	/* 2.1 Initialize themeWords filter using query parameters */

	const urlParamThemeWords = to.query.themeword;
	let themeWordsArray = [];
	if (urlParamThemeWords) {
		if (typeof urlParamThemeWords === 'object') { // multiple themeword-parameters in array
			for (let i of urlParamThemeWords) {
				themeWordsArray.push(i);
			}
		} else if (typeof urlParamThemeWords === 'string') { // single themeword-parameter
			themeWordsArray.push(urlParamThemeWords);
		}
	}

	// Get copy of current themewords and initialize them to false
	let currentThemeWordsObject = {...store.getters.themeWords};
	Object.keys(currentThemeWordsObject).forEach(key => currentThemeWordsObject[key] = false);

	// If URL query includes themeword=... parameters set matching themeword to true
	if (themeWordsArray.length) {

		let currentThemeWordsKeys = Object.keys(currentThemeWordsObject);
		for (let themeWord of themeWordsArray) {
			const index = currentThemeWordsKeys.findIndex(element => {
				// Comparisons between url and state themeWords
				return element.toLowerCase() === themeWord.toLowerCase();
			});

			// -1 for no matches, 0-N for index of matched item within currentThemeWordsKeys
			if (index !== -1) {
				currentThemeWordsObject[currentThemeWordsKeys[index]] = true;
			} else {
				currentThemeWordsObject[currentThemeWordsKeys[index]] = false;
			}
		}
	}
	store.dispatch('setThemeWords',currentThemeWordsObject);


	/* 2.2 Initialize search using query parameters */

	const urlParamSearch = to.query.search;

	if (urlParamSearch) {
		store.dispatch('setTextSearchValue', urlParamSearch);
		store.dispatch('setTextSearchStaticValue', urlParamSearch);
		setSearchResultsInformation();
	} else {
		store.dispatch('setSearchResults', { errorMessage:"", data:[] }); // Clear visible results/errors
	}

	/* 3. Load requested web content into mainContent */


	let locationDataArray = getLocationDataArray(to.path)

	/*
		Set currentItemLocationData into state 
		Note: activates currentItemLocationData watchers in ListTree.vue, each item calculates
		if they are currentItem (direct target item) or activeItem (ancestor of target item)
	*/ 
	store.dispatch('updateCurrentItemLocationData', {location: locationDataArray});

	/* 4. Load mainContent web-content */
	if (to.name == "frontpage") {
		locationDataArray = ["0"]; // Reset location if in frontpage view
	}

	// If last item is 0 prepare to load it + every child item web content of it
	let getMultiple = false;
	if (locationDataArray && locationDataArray.length) {
		if (locationDataArray[locationDataArray.length - 1] === "0") {
			getMultiple = true;
		}
		// Special case, url without location data e.g. /katsaus is set to load itself and all child items
		if (locationDataArray.length === 1 && locationDataArray[locationDataArray.length - 1] === "0") {
			locationDataArray.push("0")
			getMultiple = true
		}
	}

	// Determine and retrieve array of objects that are used to make REST call (web content request)
	let resultsArray = [];
	const rootItemContentId = store.getters['sidebarContent'][0].contentId;
	getContentObjects(locationDataArray, store.getters['sidebarContent'][0], resultsArray, getMultiple, [rootItemContentId]);

	let articleIds = "";
	resultsArray.forEach((item, index) => {
		if (index === 0) {
			articleIds += item.contentId;
		} else {
			articleIds += "," + item.contentId;
		}
	});

	const groupId = themeDisplay.getScopeGroupId();
	const encodedArticleIds = encodeURIComponent(articleIds);
	let targetUrl = '/o/indesign-rest/indesign/get-articles/' + "groupId/" + groupId + "/articleIds/" + encodedArticleIds

	axios.get(targetUrl, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json'}, timeout: 30000 }).then(response => {
			for (let i = 0; i < response.data.articles.length; i++) {

				// Loop through every item that was used to make the search
				for (let y = 0; y < resultsArray.length; y++) {
					if (response.data.articles[i].header === resultsArray[y].name) {

						response.data.articles[i].locationData = resultsArray[i].locationData;
						response.data.articles[i].contentId = resultsArray[i].contentId;
		
						// Set article themeWords as an object, instead of array with single object content
						response.data.articles[i].themeWords = response.data.articles[i].themeWords[0];

						break;
					}
				}
			}

			store.dispatch('setMainContent', response.data.articles);
			
			/* 5. Refresh sidebar and main content themeWords active status */
			store.dispatch('changeSidebarThemeWordsState', store.getters.themeWords);
			store.dispatch('changeMainContentThemeWordsState', store.getters.themeWords);

			/* 6. Set info about main content having actually visible items during themeWords filtering to state */
			let mainContentHasItemsWithActiveThemeWords = false;
			store.getters['mainContent'].forEach(item => {
				if (item.themeWordsActive == true) mainContentHasItemsWithActiveThemeWords = true;
			});
			store.dispatch('setMainContentHasItemsWithActiveThemeWords', mainContentHasItemsWithActiveThemeWords);

			// Finish by setting tukaReady value to true
			store.dispatch('tukaReady', true);

			// Allow scroll events to trigger
			Vue.nextTick(function() {
				setTimeout(() => {
					store.dispatch('setScrollingReserved', false);
				}, 2000)
			});

		}).catch(error => {
			
			// If you get zero results display alert message
			store.dispatch('setMainContent', [
				{
					header: i18n.messages[i18n.locale].tuka.messages.no_web_content.header,
					content: i18n.messages[i18n.locale].tuka.messages.no_web_content.content
				}
			]);

			// Finish by setting tukaReady value to true
			store.dispatch('tukaReady', true);

			// Allow scroll events to trigger
			Vue.nextTick(function() {
				setTimeout(() => {
					store.dispatch('setScrollingReserved', false);
				}, 2000)
			});

	})
}

function setSearchResultsInformation() {

	// Get all sidebar items that match with [] location (returns all items)
	let resultsArray = [];
	const rootItemContentId = store.getters['sidebarContent'][0].contentId;
	getContentObjects([], store.getters['sidebarContent'][0], resultsArray, true, [rootItemContentId]);

	let contentIdArray = [];
	let articleIds = "";
	resultsArray.forEach((item, index) => {
		if (index === 0) {
			articleIds += item.contentId;
		} else {
			articleIds += "," + item.contentId;
		}
		contentIdArray.push(item.contentId);
	});

	const groupId = themeDisplay.getScopeGroupId();
	const encodedWordSearch = encodeURIComponent(store.getters['getTextSearchStaticValue']);
	const encodedArticleIds = encodeURIComponent(articleIds);
	let targetUrl = '/o/indesign-rest/indesign/search-articles/' + "groupId/" + groupId + "/keyword/" + encodedWordSearch + "/articleIds/" + encodedArticleIds

	axios.get(targetUrl, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json'}, timeout: 30000 }).then(response => {

			afterSearchResponse(resultsArray, response);
			
		}).catch(error => {
			store.dispatch('setSearchResults', {
				errorMessage: i18n.messages[i18n.locale].tuka.messages.no_search_results,
				data: []
			})
		})
}

function afterSearchResponse(resultsArray, response) {

	if (response.data.results.length) {

		// Loop through every result item
		for (let i = 0; i < response.data.results.length; i++) {

			// Loop through every item that was used to make the search
			for (let y = 0; y < resultsArray.length; y++) {
				if (response.data.results[i].articleId === resultsArray[y].contentId) {

					// Add existing data from matching search item into result item
					// TODO?: add header to backEnd results 
					response.data.results[i].header = resultsArray[y].name;
					response.data.results[i].locationData = resultsArray[y].locationData;
					response.data.results[i].childItems = resultsArray[y].items.length; 
					break;
				}
			}
		}

		store.dispatch('setSearchResults', {
			errorMessage: "",
			data: response.data.results
		})

	} else {
		store.dispatch('setSearchResults', {
			errorMessage: i18n.messages[i18n.locale].tuka.messages.no_search_results,
			data: []
		})
	}

}